import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Dumbbell, Activity } from 'lucide-react';
import { scoreBucket, toneClass } from '../../../utils/coachLanguage';

const SessionFlashCard = ({ data }) => {
  if (!data?.session_id) return null;
  const bucket = (data.overall_score !== null && data.overall_score !== undefined) ? scoreBucket(data.overall_score) : null;
  const when = data.completed_at ? new Date(data.completed_at).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : '';
  return (
    <Link to={`/sessions/${data.session_id}`} className="block rounded-sm border border-zinc-700 bg-zinc-900/40 p-4 hover:border-primary transition-colors" data-testid="card-session-flash">
      <div className="flex items-center justify-between mb-2">
        <p className="text-[10px] text-zinc-500 uppercase tracking-wider">Last session</p>
        {when && <span className="text-[10px] text-zinc-500">{when}</span>}
      </div>
      <h4 className="font-secondary font-bold text-sm mb-2">{data.workout_name || 'Workout'}</h4>
      <div className="flex items-center gap-4 text-xs text-zinc-400">
        {data.overall_score !== null && data.overall_score !== undefined && (
          <span className={`font-secondary font-bold ${bucket ? toneClass(bucket.tone) : ''}`}>
            <Activity className="w-3 h-3 inline mr-1" />{Math.round(data.overall_score)}
            {bucket && <span className="ml-1 text-[10px] text-zinc-500">{bucket.label}</span>}
          </span>
        )}
        {data.exercises_captured > 0 && (
          <span><Dumbbell className="w-3 h-3 inline mr-1" />{data.exercises_captured} ex</span>
        )}
        {data.total_reps_captured > 0 && (
          <span><Clock className="w-3 h-3 inline mr-1" />{data.total_reps_captured} reps</span>
        )}
      </div>
      <p className="text-[10px] text-primary mt-2 text-right">Open analysis →</p>
    </Link>
  );
};

export default SessionFlashCard;
